import { render, staticRenderFns } from "./EditMetaData.vue?vue&type=template&id=7bbae606&scoped=true&"
import script from "./EditMetaData.vue?vue&type=script&lang=js&"
export * from "./EditMetaData.vue?vue&type=script&lang=js&"
import style0 from "./EditMetaData.vue?vue&type=style&index=0&id=7bbae606&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbae606",
  null
  
)

export default component.exports